import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import './App.css';
// components
import Header from './components/Header';
import Top from './components/Top';
import Profile from './components/Profile';
// hooks
import { useScrollToAnchor } from "./hooks/useScrollToAnchor";

function App() {
  const { scrollToAnchor } = useScrollToAnchor({ smooth: true });

  useEffect(() => {
    scrollToAnchor();
  }, [scrollToAnchor]);

  return (
    <div className="App">
      <Header/>
      <Routes>
        <Route path="/" element={<Top />}/>
        <Route path="/top" element={<Top />}/>
        <Route path="/profile" element={<Profile />}/>
        <Route path="*" element={<Top />}/>
      </Routes>
    </div>
  );
}

export default App;
